module.exports = __webpack_public_path__ + "img/js.241a3151.svg";